import { render, staticRenderFns } from "./AppVersionPopup.vue?vue&type=template&id=40e490f4&scoped=true"
import script from "./AppVersionPopup.vue?vue&type=script&lang=ts"
export * from "./AppVersionPopup.vue?vue&type=script&lang=ts"
import style0 from "./AppVersionPopup.vue?vue&type=style&index=0&id=40e490f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e490f4",
  null
  
)

export default component.exports